import { Toast } from '@/services/ui'

export const useToast = () => {
  return {
    toast: Toast,
    success: Toast.success.bind(Toast),
    error: Toast.error.bind(Toast),
    warning: Toast.warning.bind(Toast),
    info: Toast.info.bind(Toast),
    dismiss: Toast.dismiss.bind(Toast),
    dismissAll: Toast.dismissAll.bind(Toast),
  }
}
